import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlContainer, FormArray, FormBuilder, FormGroupDirective, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { catchError, throwError } from 'rxjs';
import { ClientService } from 'src/app/service/client.service';
import { ForexDerivativesService } from 'src/app/service/forex-derivatives.service';
declare var $: any;

@Component({
  selector: 'app-counter-party-dtls',
  templateUrl: './counter-party-dtls.component.html',
  styleUrls: ['./counter-party-dtls.component.css'],
  viewProviders: [{
    provide: ControlContainer, useExisting: FormGroupDirective
  }]
})
export class CounterPartyDtlsComponent implements OnInit, OnChanges {

  counterPartyData: any = [];
  clientData: any =[];

  @Input()
  counterPrty: any;

  @Input()
  action: string;

  constructor(private fb: FormBuilder,
    public fgd: FormGroupDirective,
    private cdref: ChangeDetectorRef,
    private fsService: ForexDerivativesService,
    private clientService: ClientService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService) { }

  ngOnInit(): void {
    this.getCounterPartyData();
    this.getClientsForSegment();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.fgd.form.addControl('cntrMemType', this.fb.control({ value: this.counterPrty?.cntrMemType || 'INTERBANK', disabled: (this.action == 'reversal' || this.action == 'view' || this.action == 'edit') }, Validators.required));
    this.fgd.form.addControl('cntrMemId', this.fb.control({ value: this.counterPrty?.cntrMemId || '', disabled: this.action == 'reversal' || this.action == 'view' }, Validators.required));
    this.fgd.form.addControl('cntrMemName', this.fb.control({ value: this.counterPrty?.cntrMemName || '', disabled: this.action == 'reversal' || this.action == 'view' }, Validators.required))
    this.fgd.form.addControl('cntrPrtyLei', this.fb.control({ value: this.counterPrty?.cntrPrtyLei || '', disabled: this.action == 'reversal' || this.action == 'view' }, Validators.required));
    this.cdref.detectChanges();
    $('.selectpicker').selectpicker('refresh');
  }

  get counterPrtyData() { return this.fgd.form.controls };

  getCounterPartyData() {
    this.fsService.getCounterPartyListInterbank().pipe(
      catchError((error: any) => {
        this.spinner.hide();
        if (error.statusCode != 200) {
          this.toastr.error(error.message);
        }
        return throwError(error.error)
      })
    ).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.counterPartyData = response.data;
      }
      this.cdref.detectChanges();
      $('.selectpicker').selectpicker('refresh');
    })

  }

  selectCounterParty() {
    let counterParty = this.counterPartyData.find(data => data.entityCode == this.counterPrtyData.cntrMemId.value)
    this.counterPrtyData.cntrMemName.setValue(counterParty.userName);
    this.counterPrtyData.cntrPrtyLei.setValue(counterParty.leiCode);
  }

  getClientsForSegment(){
    this.clientService.getClientsForSegment("interestRateSwap").pipe(
      catchError((error: any) => {
        this.spinner.hide();
        if (error.statusCode != 200) {
          this.toastr.error(error.message);
        }
        return throwError(error.error)
      })
    ).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.clientData = response.data;
      }
      this.cdref.detectChanges();
      $('.selectpicker').selectpicker('refresh');
    })

  }


  selectClient() {
    let client = this.clientData.find(data => data.clientID == this.counterPrtyData.cntrMemId.value)
    this.counterPrtyData.cntrMemName.setValue(client.clientName);
    this.counterPrtyData.cntrPrtyLei.setValue(client.clientLEICode);
  }

  enableDropdown(event: any){
    this.cdref.detectChanges();
      $('.selectpicker').selectpicker('refresh');
  }
}
